import React, { useState } from "react";
import { Box } from "@mui/material";
import BackButton from "../components/BackButton";
import AddButtonToImage from "../components/AddButtonToImage";
import { viewableUrlFile } from "../utils/utilityFunction";

export const SCALE = 10;
const EditPage = ({ page, onBack }) => {
  const [IMG_1, IMG_2] = page?.images;
  const IMAGE_1_URL = viewableUrlFile(IMG_1?.image_url);
  const IMAGE_2_URL = viewableUrlFile(IMG_2?.image_url);

  const [needRefresh, setNeedRefresh] = useState(false);

  if (!IMAGE_1_URL && !IMAGE_2_URL) {
    return (
      <>
        <BackButton onBack={() => onBack(false)} />
        <h1>No Image</h1>
      </>
    );
  }

  return (
    <Box component="div" className="md-editPage">
      <BackButton onBack={() => onBack(needRefresh)} />
      {IMAGE_1_URL && (
        <AddButtonToImage
          image={IMG_1}
          setNeedRefresh={setNeedRefresh}
          unitId={page.unitId}
        />
      )}
      {IMAGE_2_URL && (
        <AddButtonToImage
          image={IMG_2}
          setNeedRefresh={setNeedRefresh}
          unitId={page.unitId}
        />
      )}
    </Box>
  );
};

export default EditPage;
